import {Component, inject, OnInit, ViewChild} from '@angular/core';
import {ButtonDirective} from "primeng/button";
import {TranslatePipe, TranslateService} from "@ngx-translate/core";
import {InputTextModule} from "primeng/inputtext";
import {TableModule} from "primeng/table";
import {
  CustomTableHeader,
  DEFAULT_DATE_FORMAT,
  IColumns, SafeResourcePipe,
  SvgLoaderComponent,
  Utils
} from "lib-base";
import {MessageService} from "primeng/api";
import {firstValueFrom, forkJoin, lastValueFrom} from "rxjs";
import {DatePipe, NgClass, NgIf, NgStyle, TitleCasePipe} from "@angular/common";
import {TagModule} from "primeng/tag";
import {ActivatedRoute, Router} from "@angular/router";
import {FormsModule} from "@angular/forms";
import {TramActividadService} from "../../../services/tramActividad.service";
import {IGetTramiteActividades, IGetTramitesUsuario} from "../../../shared/interfaces/tramite";
import {TramRegistroService} from "../../../services/tramiteRegistro.service";
import {SkeletonModule} from "primeng/skeleton";
import {IconsComponent} from "../../../components/global/icons/icons.component";
import {DividerModule} from "primeng/divider";
import {AsidePublicComponent} from "../aside-public/aside-public.component";

@Component({
  selector: 'app-estado-tramites-pub',
  standalone: true,
  imports: [
    ButtonDirective,
    InputTextModule,
    TableModule,
    CustomTableHeader,
    DatePipe,
    TagModule,
    FormsModule,
    SkeletonModule,
    NgIf,
    SvgLoaderComponent,
    TitleCasePipe,
    DividerModule,
    SafeResourcePipe,
    AsidePublicComponent
  ],
  templateUrl: './estado-tramites-pub.component.html',
  styleUrl: './estado-tramites-pub.component.scss'
})
export class EstadoTramitesPubComponent implements OnInit {

  columns!: IColumns[];
  translations: any = {};
  size: number = 5;
  detalleTramite!: Required<IGetTramitesUsuario> | null;
  actividades: IGetTramiteActividades[] = [];
  radicado: string;
  tramite: string = '';
  loadingActividades:boolean = false;
  loadingTramite:boolean = false;
  readonly defaultDateFormat = DEFAULT_DATE_FORMAT;
  private basePath: string = '';

  constructor(private _ar: ActivatedRoute, private _ms: MessageService, private _t: TranslateService,
              private _tramActividadService:TramActividadService, private router : Router,
              private _tramRegistroService:TramRegistroService) {
    this.radicado = this._ar.snapshot.params['radicado'] ?? '';
  }

  async ngOnInit() {
    await this.translate();
    this.configureColumns();
    if (this.radicado) this.buscar()
    this._ar.parent?.url.subscribe((url) => {
      this.basePath = url[0]?.path;
    });
  }

  private async translate(): Promise<void> {
    this.translations = await firstValueFrom(forkJoin({
      titleMain: this._t.get('components.app-estado-tramite-pub.title-main'),
      subtitleMain: this._t.get('components.app-estado-tramite-pub.subtitle-main'),
      titleCardMain: this._t.get('components.app-estado-tramite-pub.title-card-main'),
      dependencia: this._t.get('common.dependencia'),
      estadoTramite: this._t.get('components.app-estado-tramite-pub.estado-tramite'),
      fechaTramite: this._t.get('components.app-estado-tramite-pub.fecha-tramite'),
      horaTramite: this._t.get('components.app-estado-tramite-pub.hora-tramite'),
      volverConsultar: this._t.get('components.app-estado-tramite-pub.volver-a-consultar'),
      consultar: this._t.get('components.app-estado-tramite-pub.consultar'),
      actividadesDelTramite: this._t.get('components.app-estado-tramite-pub.actividades-del-tramite'),
      busquedaTramite: this._t.get('components.app-estado-tramite-pub.busqueda-tramite'),
      tuTramite: this._t.get('components.app-estado-tramite-pub.tu-tramite'),
      buscarTramite: this._t.get('components.app-estado-tramite-pub.buscar-tramite'),

      actividad: this._t.get('common.actividad'),
      usuarioAsignado: this._t.get('common.usuario-asignado'),
      estado: this._t.get('common.estado'),
      fechaFinal: this._t.get('common.fecha-final'),
      noHayRegistros: this._t.get('msg.no-hay-registros'),
      noHayRegistrosDetalle: this._t.get('common.valide-consulta'),
      completeCampos: this._t.get('form.msg.complete-campos'),
      warnSummary: this._t.get('form.msg.warn-summary'),
    }));
  }

  getSeverity(state: string): 'success' | 'info' | 'warning' | 'danger' {
    switch (state) {
      case 'ACTIVO':
        return 'info';
      case 'FINALIZADO':
        return 'success';
      case 'RECHAZADO':
        return 'danger';
      default:
        return 'info';
    }

  }

  configureColumns() {
    this.columns = [
      {
        id: 'rowindex-column',
        field: '',
        header: 'No.',
        sort: false,
        columnFilter: false,
        class: 'text-left pl-0 color-blue-2 border-blue-2 border-none border-bottom-2 border-solid'
      },
      {
        id: 'actividad-column',
        field: 'actividad',
        header: this.translations.actividad,
        sort: false,
        columnFilter: false,
        class: 'text-left color-blue-2 border-blue-2 border-none border-bottom-2 border-solid'
      },
      {
        id: 'usuarioAsignado-column',
        field: 'usuarioAsignado',
        header: this.translations.usuarioAsignado,
        sort: false,
        columnFilter: false,
        class: 'text-left color-blue-2 border-blue-2 border-none border-bottom-2 border-solid'
      },
      {
        id: 'estado-column',
        field: 'estado',
        header: this.translations.estado,
        sort: false,
        columnFilter: false,
        class: 'text-left color-blue-2 border-blue-2 border-none border-bottom-2 border-solid'
      },
      {
        id: 'fecha-final-column',
        field: 'fechaFinal',
        header: this.translations.fechaFinal,
        sort: false,
        columnFilter: false,
        class: 'text-left color-blue-2 border-blue-2 border-none border-bottom-2 border-solid'
      }
    ];
  }

  buscar() {
    if (!this.radicado) {
      this._ms.add({
        severity: 'warn',
        summary: this.translations.warnSummary,
        detail: this.translations.completeCampos
      });
      return;
    }
    this.getActividadesTramitesByRadicado(this.radicado)
    this.getTramiteByRadicado(this.radicado)
  }

  getActividadesTramitesByRadicado(radicado: string): void {
    this.loadingActividades = true;
    lastValueFrom(this._tramActividadService.getTramiteActividadesByRadicado(this.radicado))
      .then((data) => {
        this.actividades = data;
        this.loadingActividades = false;
      }).catch((error) => {
      this.loadingActividades = false;
    });
  }

  getTramiteByRadicado(radicado: string): void {
    this.loadingTramite = true;
    lastValueFrom(this._tramRegistroService.getTramiteByRadicado(this.radicado))
      .then((data) => {
        this.detalleTramite = data;
        this.loadingTramite = false;
      }).catch((error) => {
      this.loadingTramite = false;
      this.detalleTramite = null;
    });
  }
  getTramiteEstadoTagIcon(estado: string, usuarioAsignadoCorreo: string): string {
    return Utils.getTramiteEstadoTagIcon(estado, usuarioAsignadoCorreo);
  }

  getTramiteTagIcon(estado:string):string{
    if (estado == 'ACTIVO') {
      return 'pi pi-flag';
    } else if (estado == 'FINALIZADO') {
      return 'pi pi-star-fill';
    } else {
      return 'pi pi-times';
    }

  }

  getTramiteEstadoTagSeverity(estado: string, usuarioAsignadoCorreo: string): 'success' | 'secondary' | 'info' | 'warning' | 'danger' | 'contrast' {
    return  Utils.getTramiteEstadoTagSeverity(estado, usuarioAsignadoCorreo);
  }


  searchTramites() {
    if (!this.tramite) {
      this._ms.add({
        severity: 'warn',
        summary: this.translations.warnSummary,
        detail: this.translations.completeCampos
      });
      return;
    }
    this.router.navigate([this.basePath, 'consulta', this.tramite]).then();

  }
}
